export default {
  colors: {
    muted: {
      default: 'gray.500',
      _dark: 'gray.400',
    },
  },
}
